/**
 * StudentValidateEmailScreen — « Valider l'email » de l'élève (route `validate-email`), à la place de
 * `common/account/ValidateEmailScreen.js` quand l'espace élève est allumé.
 *
 * Patron A : le compte relu à l'ouverture et sur « Actualiser » (`useStudentValidateEmailData`),
 * lu par `studentValidateEmailViewModel`, les gestes et le renvoi de l'email dans
 * `useStudentValidateEmailState`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentValidateEmailPage } from "../../../../../../design-system/student"
import { studentValidateEmailViewModel } from "../../../../view-models/student/Account/studentValidateEmailViewModel"
import { useStudentValidateEmailData } from "./useStudentValidateEmailData"
import { useStudentValidateEmailState } from "./useStudentValidateEmailState"

export function StudentValidateEmailScreen() {
    const { check } = useStudentValidateEmailData()
    const vm = useSelector(studentValidateEmailViewModel)
    const state = useStudentValidateEmailState(vm, check)

    return <StudentValidateEmailPage email={vm.email} checking={vm.checking} {...state} />
}
